import { InjectionToken } from '@angular/core';
import {
  ActionReducer,
  ActionReducerMap,
  MetaReducer,
  Action,
} from '@ngrx/store';

import { environment } from '../../environments/environment';
import * as fromAvailability from '../core/reducers/availability.reducer';
import * as fromDateOfStay from '../core/reducers/date-of-stay.reducer';
import * as fromDestination from '../core/reducers/destination.reducer';
import * as fromLayout from '../core/reducers/layout.reducer';
import * as fromOrder from '../core/reducers/order.reducer';
import * as fromOwner from '../core/reducers/owner.reducer';
import * as fromProduct from '../core/reducers/product.reducer';
import * as fromMappedAreas from '../core/reducers/mapped-area.reducer';

import * as AvailabilitySelector from './availability.selectors';
import * as DestinationSelectors from './destination.selectors';
import * as DateOfStaySelectors from './date-of-stay.selectors';
import * as OrderSelectors from './order.selectors';
import * as OwnerSelectors from './owner.selectors';
import * as ProductSelectors from './product.selectors';
import * as LayoutSelectors from './layout.selectors';
import * as MappedAreaSelectors from './mapped-area.selectors';
import { OrderTimeoutActions } from '../core/actions';

/**
 * App state definition
 */
export interface ApplicationState {
  [fromAvailability.availabilityFeatureKey]: fromAvailability.State;
  [fromDateOfStay.dateOfStayFeatureKey]: fromDateOfStay.State;
  [fromDestination.destinationFeatureKey]: fromDestination.State;
  [fromLayout.layoutFeatureKey]: fromLayout.State;
  [fromOrder.orderFeatureKey]: fromOrder.State;
  [fromProduct.productFeatureKey]: fromProduct.State;
  [fromOwner.ownerFeatureKey]: fromOwner.State;
  [fromMappedAreas.mappedAreaFeatureKey]: fromMappedAreas.State;
}

/**
 * Main app reducer
 */
export const ROOT_REDUCERS = new InjectionToken<
  ActionReducerMap<ApplicationState, Action>
>('Root reducers token', {
  factory: () => ({
    [fromAvailability.availabilityFeatureKey]: fromAvailability.reducer,
    [fromDateOfStay.dateOfStayFeatureKey]: fromDateOfStay.reducer,
    [fromDestination.destinationFeatureKey]: fromDestination.reducer,
    [fromLayout.layoutFeatureKey]: fromLayout.reducer,
    [fromOrder.orderFeatureKey]: fromOrder.reducer,
    [fromProduct.productFeatureKey]: fromProduct.reducer,
    [fromOwner.ownerFeatureKey]: fromOwner.reducer,
    [fromMappedAreas.mappedAreaFeatureKey]: fromMappedAreas.reducer,
  }),
});


/**
 * Meta reducers / middleware
 *
 * @param reducer App reducer
 */
export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    const result = reducer(state, action);

    if (action.type !== OrderTimeoutActions.updateTimeout.type) {
      console.groupCollapsed(action.type);
      console.log('prev state', state);
      console.log('action', action);
      console.log('next state', result);
      console.groupEnd();
    }

    return result;
  };
}

export const metaReducers: MetaReducer<ApplicationState>[] = environment.envName !== 'prod' ?
  [logger] :
  [];

export {
  AvailabilitySelector,
  DestinationSelectors,
  DateOfStaySelectors,
  LayoutSelectors,
  OrderSelectors,
  OwnerSelectors,
  ProductSelectors,
  MappedAreaSelectors,
};
